module.exports = __webpack_public_path__ + "fonts/VetoSans-Light.216e7f74.woff";